import React, {useEffect, useState} from 'react';
import {useLocation} from "react-router-dom";
import './AssetDetails.css';
import '../../ExcelUploads/AssetInfo/AssetList.css';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import FromFieldText from '../../../atoms/FromFieldText';
import {getDepreciation, getAssetBasicDetails} from '../../../services/asset.service';
import {getDepartmentList} from '../../../services/user.service';
import * as CryptoJS from "crypto-js";

/* ─── Date Helpers (unchanged) ─── */
Date.prototype.dbFormatedDate = function () {
    let year = this.getFullYear();
    let month = this.getMonth() + 1;
    let day = this.getDate();
    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;
    return year + '-' + month + '-' + day;
}

function getFormatedDate(dateString) {
    if (dateString !== null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) month = '0' + month;
        if (day < 10) day = '0' + day;
        return year + '-' + month + '-' + day;
    } else {
        return null;
    }
}

function TabPanel(props) {
    const {children, value, index, ...other} = props;
    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && (
                <Box sx={{p: 3}}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function AssetBasicDetails() {
    /* ─── All State (unchanged) ─── */
    const [value, setValue] = useState(0);
    const [tag, setTag] = useState(0);
    const [assetInfo, setAssetInfo] = useState(0);
    const [loading, setLoading] = useState(false);
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const Tag = query.get('tag');
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);
    const [back_url, setBackUrl] = useState(false);
    const [departments, setDepartments] = useState([]);

    /* ─── All useEffect & Handlers (unchanged logic) ─── */
    useEffect(() => {
        if (Tag !== '' && Tag !== null) {
            const decryptedBytes = CryptoJS.AES.decrypt(Tag.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
            const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
            const decryptedTag = decrypt_data.tag;
            setBackUrl(decrypt_data?.back_url);
            getTagAutoInfo(decryptedTag);
        }
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = {'token': EncryptData}
        getDepartmentList(oData).then(res => {
            if (res?.data?.data?.length) setDepartments(res.data.data);
        });
    }, []);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const getTagAutoInfo = function (Tag) {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': {'tag': Tag},
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = {'token': EncryptData}
        getAssetBasicDetails(oData).then(function (res) {
            if (res?.data?.data) {
                setErrMsg('');
                var {assetInfo} = res.data.data;
                setAssetInfo(assetInfo);
            } else {
                setAssetInfo({});
                setErrMsg('Assets Not Found');
            }
        })
    }

    const getTagInfo = function () {
        if (tag == '') {
            setErrMsg('Enter Assets');
        } else {
            setErrMsg('');
            try {
                setLoading('..');
                let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                    'param_data': {'tag': tag},
                    'authToken': sessionStorage.getItem('LoggedInToken'),
                }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                let oData = {'token': EncryptData}
                getDepreciation(oData).then(function (res) {
                    if (res.status === 200) {
                        var data = res?.data?.data;
                        if (data?.assetInfo && data?.assetDeprisiation) {
                            setErrMsg('');
                            setAssetInfo(data.assetInfo);
                        } else {
                            setAssetInfo({});
                            setErrMsg('Assets Not Found');
                        }
                    }
                });
                setLoading(false);
            } catch (err) {
                setLoading(false);
            }
        }
    }

    /* ─── RENDER ─── */
    return (
        <div className="al-page" id="asset-basic-details-page">

            {/* ══ PAGE HEADER ══ */}
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-info-circle-fill"/>
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">Asset Basic Details</h5>
                        <p className="al-page-subtitle">View essential asset information</p>
                    </div>
                </div>
                <div className="al-header-actions">
                    {(back_url !== '' && back_url !== undefined && back_url !== false) ? (
                        <a href={'/' + back_url}>
                            <button className='al-btn al-btn-outline al-btn-sm'>
                                <i className="bi bi-arrow-left"/> Back
                            </button>
                        </a>
                    ) : (
                        <a href={'/my-asset-list'}>
                            <button className='al-btn al-btn-outline al-btn-sm'>
                                <i className="bi bi-arrow-left"/> Back
                            </button>
                        </a>
                    )}
                </div>
            </div>

            {/* ══ SEARCH SECTION (if no TAG in URL) ══ */}
            {!(Tag !== '' && Tag !== null) && (
                <div className="al-filter-card" id="al-search-card">
                    <div className="al-filter-card-header">
                        <span className="al-filter-card-title">
                            <i className="bi bi-search"/> Search Asset by TAG
                        </span>
                    </div>
                    <div className="al-filter-card-body">
                        <div className="al-filter-grid" style={{gridTemplateColumns: '1fr auto', gap: '16px', alignItems: 'flex-end'}}>
                            <div className="al-filter-group">
                                <label className="al-filter-label">Asset TAG</label>
                                <input
                                    onChange={function (event) { setTag(event.target.value) }}
                                    inputValue={assetInfo.tag}
                                    type="text"
                                    className="al-form-input"
                                    placeholder='Enter the asset TAG'
                                />
                            </div>
                            <div className="al-filter-group" style={{marginBottom: 0}}>
                                <button onClick={getTagInfo} className='al-btn al-btn-primary'>
                                    <i className="bi bi-search"/> Search Asset
                                </button>
                            </div>
                        </div>
                        {loading && (
                            <div className="spinner-border text-primary" role="status" style={{marginTop: '12px'}}>
                                <span className="sr-only">{loading}</span>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* ══ TABS & CONTENT ══ */}
            <div className="al-grid-card" id="al-details-tabs-card">
                <Box sx={{width: '100%'}}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            aria-label="asset basic details tabs"
                            sx={{
                                '& .MuiTab-root': {
                                    fontFamily: 'var(--font-body, "DM Sans", sans-serif)',
                                    fontWeight: 600,
                                    fontSize: '0.85rem',
                                    textTransform: 'none',
                                    color: 'var(--clr-muted, #64748b)',
                                    '&.Mui-selected': {
                                        color: '#0e8aca',
                                    },
                                },
                                '& .MuiTabs-indicator': {
                                    backgroundColor: '#0e8aca',
                                    height: 3,
                                },
                            }}
                        >
                            <Tab label="Information" {...a11yProps(0)} />
                        </Tabs>
                    </Box>

                    {/* TAB 0: Information */}
                    <TabPanel value={value} index={0}>
                        <div className='row'>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="TAG" inputValue={assetInfo.tag}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Parent TAG" inputValue={assetInfo.parent_tag}/></div>

                            <div className='col-6'><FromFieldText readOnly="readonly" label="Year of Addition" inputValue={assetInfo.year_of_addition}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Type of Addition" inputValue={assetInfo.type_of_addition}/></div>

                            <div className='col'><FromFieldText readOnly="readonly" label="Project Marking" inputValue={assetInfo.project_marking}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="PO No (If Any)" inputValue={assetInfo.po_no}/></div>

                            <div className='col-6'><FromFieldText readOnly="readonly" label="Supplier Code (if Any)" inputValue={assetInfo.supplier_code}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Name of the Supplier" inputValue={assetInfo.supplier_name}/></div>

                            <div className='col-6'><FromFieldText readOnly="readonly" label="Invoice No" inputValue={assetInfo.invoice_no}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Invoice Date" inputValue={assetInfo.invoice_date ? getFormatedDate(assetInfo.invoice_date) : ''}/></div>

                            <div className='col-6'><FromFieldText readOnly="readonly" label="Bill of Entry No" inputValue={assetInfo.boe_no}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Date of BOE" inputValue={assetInfo.boe_date ? getFormatedDate(assetInfo.boe_date) : ''}/></div>

                            <div className='col-6'><FromFieldText readOnly="readonly" label="Shipping / AWB No" inputValue={assetInfo.shipping_awb_no}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Date of Shipping/AWB" inputValue={assetInfo.shipping_awb_date ? getFormatedDate(assetInfo.shipping_awb_date) : ''}/></div>

                            <div className='col-6'><FromFieldText readOnly="readonly" label="Accounting Voucher No." inputValue={assetInfo.accounting_voucher_no}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Internal Approval No" inputValue={assetInfo.internal_approval_no}/></div>

                            <div className='col-6'><FromFieldText readOnly="readonly" label="Cost Center Code" inputValue={assetInfo.cost_center_code}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Cost Center Name" inputValue={assetInfo.cost_center_name}/></div>

                            <div className='col-6'><FromFieldText readOnly="readonly" label="Qty" inputValue={assetInfo.qty}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Unit Of Measure" inputValue={assetInfo.unit_of_measure}/></div>

                            <div className='col-6'><FromFieldText readOnly="readonly" label="Name of the Asset (as per Invoice)" inputValue={assetInfo.asset_name}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Detailed Description of the Asset" inputValue={assetInfo.asset_description}/></div>

                            <div className='col-6'><FromFieldText readOnly="readonly" label="Nature of Presence" inputValue={assetInfo.nature_of_presence}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Nature of Addition" inputValue={assetInfo.nature_of_addition}/></div>

                            <div className='col-6'><FromFieldText readOnly="readonly" label="Principal Asset to which Cost is Added" inputValue={assetInfo.principal_asset_tag}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Unique Sl No of the Asset" inputValue={assetInfo.asset_serial_no}/></div>

                            <div className='col-6'><FromFieldText readOnly="readonly" label="Make / Manufacturer" inputValue={assetInfo.manufacturer}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Model No" inputValue={assetInfo.model_no}/></div>

                            <div className='col-6'><FromFieldText readOnly="readonly" label="Part No" inputValue={assetInfo.part_no}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Comp Ref. No." inputValue={assetInfo.comp_ref_no}/></div>

                            <div className='col-6'><FromFieldText readOnly="readonly" label="Asset TAG Name" inputValue={assetInfo.tag_name}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Asset TAG Branch" inputValue={assetInfo.tag_division}/></div>

                            <div className='col-6'><FromFieldText readOnly="readonly" label="Security Seal Date" inputValue={assetInfo.security_seal_date ? getFormatedDate(assetInfo.security_seal_date) : ''}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Control Department" inputValue={(departments && departments.length) > 0 ? (departments.filter(option => assetInfo.ownership_id === option.id).map(option => option.department_name).join(', ')) : ('')}/></div>
                        </div>
                    </TabPanel>
                </Box>
            </div>
        </div>
    )
}

export default AssetBasicDetails